import React, { useState, useEffect, useRef } from "react";
import web1 from "../assets/web1.png";
import web2 from "../assets/web2.png";
import web3 from "../assets/web3.png";
import web4 from "../assets/web4.png";
import web5 from "../assets/web5.png";

const websites = [
  {
    title: "PetLife",
    description:
      "What if caring for your beloved pets was as effortless as the joy they bring to your life? From wagging tails to gentle purrs, our pets are family – and they deserve the very best. 🐕🐾 That’s why we are creating PetLife, a smart Pet Healthcare Management Web App designed to make pet care seamless. With digital health records, care reminders, vet appointment scheduling, and even a community for pet lovers, we’re here to transform the way you nurture your furry friends. Because every bark, meow, and cuddle deserves love and care backed by innovation. 💖✨",
    techTags: ["react js", "node js", "express", "tailwind css", "redux"],
    demoLink: "https://www.pet-lifes.com",
    logo: "https://www.pet-lifes.com/static/media/logo.eaec1c36dbf4107d334d.png",
    previewImage: web2,
  },
  {
    title: "Video Downloader",
    description:
      "Video Downloader Web App A Node.js-powered video downloader for downloading videos from popular platforms like YouTube, Facebook, TikTok, and Instagram. This web app uses HBS templates, HTML, and CSS to deliver a clean, responsive interface for seamless video downloads.",
    techTags: ["html", "css", "hbs", "node js", "express"],
    demoLink: "https://videodownloaderv2.vercel.app/",
    logo: "https://videodownloaderv2.vercel.app/img/logo.png",
    previewImage: web1,
  },

  {
    title: "VCU Calculators",
    description:
      "A React-based application featuring three interactive calculators for financial planning.",
    techTags: ["react", "tailwind css"],
    demoLink: "https://calculators-peach.vercel.app/",
    logo: "https://udithavithanage.vercel.app/static/media/logo.0bfee360c9c16e57fd8d.png",
    previewImage: web3,
  },
  {
    title: "ABC Health & Fitness",
    description: `This is a simple, responsive website for "ABC Health & Fitness." It highlights the company's services and provides essential contact details.`,
    techTags: ["html", "css", "js"],
    demoLink: "https://udithavithanage.github.io/geeshan/",
    logo: "https://png.pngtree.com/png-vector/20241224/ourlarge/pngtree-3d-bold-a-alphabet-on-transparent-background-png-image_14824733.png",
    previewImage: web4,
  },
  {
    title: "Mr. Uditha",
    description: `This is a personal portfolio website built using HTML, CSS, and JavaScript. It showcases my education, skills, services, and projects in a clean and responsive design. The website features dynamic content rendering with JavaScript and includes an interactive contact form powered by EmailJS.`,
    techTags: ["html", "css", "js", "email js"],
    demoLink: "https://udithavithanage.github.io/Portfolio/",
    logo: "https://udithavithanage.github.io/Portfolio/pixelcut-export.png",
    previewImage: web5,
  },
];

const WebsiteCard = ({
  title,
  description,
  techTags,
  demoLink,
  logo,
  previewImage,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const adBoxRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (adBoxRef.current) {
      observer.observe(adBoxRef.current);
    }

    return () => {
      if (adBoxRef.current) {
        observer.unobserve(adBoxRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={adBoxRef}
      className={`bg-gray-800 border border-gray-700 rounded-2xl shadow-xl transition-all duration-700 ease-out transform ${
        isVisible
          ? "opacity-100 translate-y-0 scale-100"
          : "opacity-0 translate-y-12 scale-95"
      }`}
    >
      {/* Project Preview Image with Overlay */}
      <div className="relative mb-6 overflow-hidden rounded-t-xl shadow-2xl">
        <img
          src={previewImage}
          alt="Project Preview"
          className="w-full h-56 object-cover rounded-t-xl shadow-lg"
        />
        <div className="absolute inset-0 bg-black opacity-40"></div>
      </div>

      <div className="p-6 sm:p-8">
        {/* Icon Section */}
        <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center rounded-full mx-auto sm:mx-0 mb-4">
          <img
            src={logo}
            alt="Ad Logo"
            className="rounded-full shadow-md border-4 border-white dark:border-gray-800"
          />
        </div>

        {/* Content Section */}
        <div className="text-center sm:text-left">
          <h3 className="text-2xl sm:text-3xl font-semibold text-white hover:text-yellow-500 cursor-pointer transition-all duration-300">
            {title}
          </h3>
          <p className="text-sm sm:text-base text-gray-300 mt-3 leading-relaxed lg:min-h-60">
            {description}
          </p>

          <a href={demoLink} target="_blank" rel="noopener noreferrer">
            <div className="flex mt-5 justify-center sm:justify-start">
              <div className="relative group">
                <button className="relative inline-block p-px font-semibold text-white bg-gradient-to-r from-teal-400 via-blue-500 to-purple-500 shadow-lg cursor-pointer rounded-xl transition-transform duration-300 ease-in-out hover:scale-105 active:scale-95">
                  <span className="absolute inset-0 rounded-xl bg-gradient-to-r from-teal-400 via-blue-500 to-purple-500 p-[2px] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  <span className="relative z-10 block px-6 py-3 rounded-xl bg-gray-950">
                    <div className="relative z-10 flex items-center space-x-2">
                      <span className="transition-all duration-500 group-hover:translate-x-1">
                        Live Demo
                      </span>
                      <svg
                        className="w-6 h-6 transition-transform duration-500 group-hover:translate-x-1"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          clipRule="evenodd"
                          d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                          fillRule="evenodd"
                        />
                      </svg>
                    </div>
                  </span>
                </button>
              </div>
            </div>
          </a>

          {/* Tech Stack Badges */}
          <div className="mt-4 flex flex-wrap gap-3 justify-center sm:justify-start">
            {techTags.map((tech, index) => (
              <span
                key={index}
                className="bg-gray-50 bg-opacity-20 text-yellow-200 text-xs font-semibold py-1 px-3 rounded-full transform hover:scale-105 transition-all duration-300"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const WebsiteList = () => (
  <section
    className="min-h-screen bg-gradient-to-b to-gray-900 from-black p-10 pt-20"
    id="websites"
  >
    <h2 className="text-6xl font-bold text-center text-yellow-400 mb-12">
      Web Sites
    </h2>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      {websites.map((website, index) => (
        <WebsiteCard key={index} {...website} />
      ))}
    </div>
  </section>
);

export default WebsiteList;
